import { MET_SUB_SUMMARY_ITEM } from './met-sub-summary.js'
import { MET_SUB_COLLECTION_ITEM } from './met-sub-collection.js'
import { MET_SUB_AI_REPORTS_ITEM } from './met-sub-ai-reports.js'

/** @type {import('../help-index.js').HelpScreen} */
export const MET_SUB_HELP = {
  screenId: 'met-sub',
  label: 'Suscripciones',
  navPath: 'Métricas → Suscripciones',
  keywords: [
    'metricas suscripciones',
    'métricas suscripciones',
    'mrr',
    'arr',
    'churn',
    'cuotas',
    'mora suscripciones',
    'informe ia suscripciones',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Cartera, MRR, cobranza de cuotas e informes IA de suscripciones.',
  sidebarItems: [MET_SUB_SUMMARY_ITEM, MET_SUB_COLLECTION_ITEM, MET_SUB_AI_REPORTS_ITEM],
}
